import ImagesListModalDouble from '@/components/shared/ImagesListModal/ImagesListModalDouble.vue';
import ImageItem from '@/components/shared/ImageItem/ImageItem.vue';

import { createNamespacedHelpers } from 'vuex';
const imageMapper = createNamespacedHelpers('detector/image');
const detectorMapper = createNamespacedHelpers('detector');
const historyMapper = createNamespacedHelpers('history');
const advancedSettingMapper = createNamespacedHelpers('global/advancedSetting');
const AUTO_CLOSE_TOGGLE_INDEX = 1
export default {
	components: {
		ImagesListModalDouble,
		ImageItem,
	},

	data() {
		return {
			imagesModalId: 'detectorImagesMmodal',
			slide: 0,
			hasBorder: true,
			hasTag: true,
		};
	},

	computed: {
		...imageMapper.mapState(['images']),
		...detectorMapper.mapState([
			'showCamera',
		]),
		...advancedSettingMapper.mapState(['advancedSetting']),
		
		autoCloseDetectedImgToggle() {
			return this.advancedSetting.detector[AUTO_CLOSE_TOGGLE_INDEX].settingContent;
		},

		passedImages() {
			return {
				imagesList: this.images,
				from: 'detector',
			};
		},
	},

	methods: {
		...detectorMapper.mapMutations([
			'SET_SHOW_CAMERA',
			'SET_SHOW_CAMERA_IMG_BORDER',
			'SET_PREVIEW_IMAGE_DETECTION',
			'SET_IMAGE_URI',
		]),
		...historyMapper.mapMutations(['UPDATE_NO_CHECKBOX']),
		async onChoseImage(choosenIdx) {
			this.slide = choosenIdx;
			if (this.images.length == 0) return;
			this.$bvModal.show(this.imagesModalId);
			if (!this.autoCloseDetectedImgToggle && !this.showCamera) {

				this.SET_SHOW_CAMERA(false);
				this.SET_SHOW_CAMERA_IMG_BORDER(false);
				this.SET_PREVIEW_IMAGE_DETECTION(false);
				this.UPDATE_NO_CHECKBOX(false);
				this.SET_IMAGE_URI('');
				this.SET_SHOW_CAMERA(true);
				await this.$nextTick();
				this.$eventBus.$emit('playCamera');
					
				this.SET_SHOW_CAMERA_IMG_BORDER(true);
			}

	
		},
	},
};
